import {errorToaster} from '../services/ErrorHandler'

export default function validatorPhone (mobile) {
  // eslint-disable-next-line no-console
  console.log('mobile: ', mobile);
  var vnf_regex = /((09|03|07|08|05)+([0-9]{8})\b)/g
  if (mobile !== '') {
    if (vnf_regex.test(mobile) === false) {
      errorToaster('Cố vấn phong thủy', 'Số điện thoại của bạn không đúng định dạng!')
      return false
    } else {
      return true
    }
  } else {
    errorToaster('Cố vấn phong thủy', 'Bạn chưa điền số điện thoại!')
    return false
  }
}



// WEBPACK FOOTER //
// ./src/utils/PhoneValidator.js